export default function C7LoadedPageDefault() {
    this.init = () => {
        addClassDefaultPage();
        setInterval(addCartCarrotSlideBar, 400);
    }

    const addClassDefaultPage = ()=> {
        c7.addAction("c7_page_rendered", (content) => {
            let wrap = document.getElementById('c7-content');
            wrap.classList.add('c7-render-page');
        });

        c7.addAction("c7_side_cart_rendered", (content) => {
            cartHideScroll();
        });
    }

    const cartHideScroll = ()=> {
        const targetNode = document.getElementById('c7-side-cart');
        const callback = mutations => {
            if ( targetNode.classList.contains('c7-side-cart--visible') ) {
                if( window.screen.width <= 550 ) {
                    jQuery('body').addClass('overflow-hidden');
                } else {
                    jQuery('body').removeClass('overflow-hidden');
                }

                jQuery('.c7-order-item__description').each(function (i,e) {
                    jQuery(e).html( '<ul><li>' + jQuery(e).text().split("---").join('</li><li>') + '</ul></li>' );
                })
                
            } else {
                jQuery('body').removeClass('overflow-hidden');
            }
        }
      
        const observer = new MutationObserver(callback);
      
        observer.observe( targetNode, {attributes: true, childList: true, characterData: true } );
    }

    const addCartCarrotSlideBar = () => {
        let num = Number(jQuery('.c7-user-nav__cart__count').text());
        if( num > 12 ) num = 12;
        let html = '<div class="c7-carrot__slide-bar">';
        html += '<div class="c7-carrot__slide-bar__process" qty="' + num + '">';
        html += '<span class="slide-bar__step" style="width: calc( ' + num + '/12 * 100%);"></span>';
        html += '</div>';
        html += '<div class="c7-carrot__slide-bar__text">';
        html += '<span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span><span>6</span><span>7</span><span>8</span><span>9</span><span>10</span><span>11</span><span>12</span>';
        html += '</div>';
        html += '</div>';
        if( jQuery('.c7-carrot__slide-bar').length === 0 ) {
            jQuery('.c7-carrot').append( html );
        } else {
            jQuery('.slide-bar__step').css('width', num/12*100 + '%' );
        }
    }
}